import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatAudienceEnqueuedEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from './index'

export const audienceEnqueued: CaseReducer<NinchatState> = (state, action) => {
    const {
        queue_id,
        ...properties
    } = extractProperties<NinchatAudienceEnqueuedEvent>(action.payload)

    state.user_queues ??= {}
    state.user_queues[queue_id] = {
        ...state.user_queues[queue_id],
        ...properties,
    }
}
